import { useMemo } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import uuid from 'react-uuid';
import useReorderQuestions from "./useReorderQuestions";
import { txt } from "../../../services/translation";

export default function useCreateQuestion(){

    const {quizId} = useParams()

    const {setToast} = useContext(ToastContext)

    const queryClient = useQueryClient()

    const queryKey = useMemo(() => ['design', quizId, 'questions'], [quizId]);

    const reorderQuestions = useReorderQuestions()

    return (rank) => {
        const oldQuestions = [...queryClient.getQueryData(queryKey)];

        let newQuestion = {
            id: uuid(),
            title: '',
            rank: rank - 0.5,
            section: {id: quizId},
            edit: true,
            explanation: ''
        }

        let newQuestions = [...queryClient.getQueryData(queryKey)];
        newQuestions.push(newQuestion);
        newQuestions = reorderQuestions(newQuestions)
        queryClient.setQueryData(queryKey, newQuestions);

        newQuestion = newQuestions.find(c => c.id === newQuestion.id);

        API.post(`/design/questions`, newQuestion)
            .then(r => {
                console.log(r.data)
                API.put(`/design/questions/reorder`, newQuestions)
            })
            .catch(e => {
                queryClient.setQueryData(queryKey, oldQuestions)

                setToast({
                    severity: 'error',
                    message: txt('errorOccurred')
                })
            })
    }
}